<template>
  <!-- eslint-disable -->

  <div class="limiter">
    <v-app id="inspire">
      <div class="container-login100">
        <div class="content-overlay" :style="cssProps" />
        <div class="wrap-login100">
          <div class="login-main-body-wrap">
            <div class="login-body-wrap">
              <div class="login-body-container">
                <div class="login100-pic js-tilt">
                  <div class="login-logo-wrap">
                    <img
                      class="main-logo"
                      src="@/assets/images/nic-asia-bank-2.png"
                      alt="IMG"
                    />
                  </div>
                </div>
               

                <div class="login100-form validate-form">
                  <div class="login-form-header">
                    <h2>Update Password</h2>
                  </div>
                   <div class="reset-form-header">
                      <h6>Please update your password</h6>
                  </div>
                  <ValidationObserver
                    id="loginform"
                    class="form-horizontal form-material"
                    ref="observer"
                    autocomplete="off"
                    tag="form"
                    role="form"
                    @submit.prevent="submit"
                  >
                    <div class="form-group">
                      <ValidationProvider
                        class="input-wrapper"
                        v-slot="{ errors }"
                        name="username"
                        rules="required"
                      >
                        <v-text-field
                          v-model="form.username"
                          height="45px"
                          ref="username"
                          label="User Name"
                          name="username"
                          prepend-inner-icon="mdi-account"
                        />
                        <span class="error-message">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="form-group">
                      <ValidationProvider
                        class="input-wrapper"
                        v-slot="{ errors }"
                        name="currentPassword"
                        rules="required"
                      >
                        <v-text-field
                          v-model="form.oldPassword"
                          height="45px"
                          ref="currentPassword"
                          label="Current Password"
                          name="currentPassword"
                          prepend-inner-icon="mdi-shield-lock"
                        />
                        <span class="error-message">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="form-group">
                      <ValidationProvider
                        class="input-wrapper"
                        v-slot="{ errors }"
                        name="newPassword"
                        rules="required"
                      >
                        <v-text-field
                          v-model="form.newPassword"
                          ref="newPassword"
                          name="newPassword"
                          height="45px"
                          label="New Password"
                          prepend-inner-icon="mdi-shield-lock"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          @click:append="show1 = !show1"
                          counter
                        />
                        <span class="error-message">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="form-group">
                      <ValidationProvider
                        class="input-wrapper"
                        v-slot="{ errors }"
                        name="confirmPassword"
                        rules="required|confirmed:newPassword"
                        data-vv-as="newPassword"
                      >
                        <v-text-field
                          v-model="form.confirmNewPassword"
                          height="45px"
                          ref="password"
                          prepend-inner-icon="mdi-shield-lock"
                          name="confirmPassword"
                          label="Confirm Password"
                          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show2 ? 'text' : 'password'"
                          @click:append="show2 = !show2"
                        />
                        <span class="error-message">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <div class="form-group text-center m-t-20">
                      <div class="container-login100-form-btn">
                        <v-btn
                          height="42px"
                          width="100%"
                          rounded
                          padding="0 10px"
                          color="primary"
                          type="submit"
                          :loading="loading"
                          :disabled="loading"
                        >
                          <v-icon left dark>
                            mdi-lock
                          </v-icon>
                          Change Password
                        </v-btn>
                      </div>
                    </div>
                  </ValidationObserver>
                </div>
              </div>
            </div>
            <div class="login-main-banner">
              <img src="@/assets/images/paylink.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import "@/assets/sass/pages/login.scss";
import Promise from "../../../../lib/mixins/ExtendedPromises";
import Auth from "../../../../repositories/auth";
import { encode, decode } from "js-base64";
import FormHeader from "./components/FormHeader";

export default {
  name: "PasswordReset",
  mixins: [Promise],
  components: {
    FormHeader
  },
  data() {
    return {
      isSignUp: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/images/hero_area_bg1.jpg")})`
      },
      isLoading: "",
      show1: false,
      show2: false,
      dialog: true,
      username: "",
      password: "",
      social_login_providers: [],
      form: {
        username: "",
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: ""
      },
      isLoginWrong: false,
      loading: false,
      confirmPasswordRules: [
        value => !!value || "type confirm password",
        value =>
          value === this.form.newPassword ||
          "The password confirmation does not match."
      ]
    };
  },
  computed: {
    authError() {
      return this.$store.getters.authError;
    }
  },
  methods: {
    async submit() {
      const valid = await this.$refs.observer.validate();
      if (valid) {
        this.loading = true;

        let loginDetail = { ...this.form };
        // for (const [key, value] of Object.entries(loginDetail)) {
        //   loginDetail[key] = encode(value);
        // }
        const operation = this.response(Auth.changePassword(loginDetail));

        operation
          .then(data => {
            if (operation.isFulfilled()) {
              this.$toasted.show("Password changed", {
                type: "success"
              });
              this.loading = false;
              this.$router.push("/login");
            }
          })
          .catch(err => {
            this.loading = false;
            this.$toasted.show(err.data.message, {
              type: "error"
            });
          });
      }
    }
  }
};
</script>
